<template>
	<div :class="classFather" v-show="conditional">
		<div class="alert__content">
			<h4 v-if="title"><i :class="iconClass"></i>{{ title | translate | capitalize }}</h4>
			<p>{{ message  | translate | capitalize }}</p>
			<span v-show="linkShow"><router-link :to="linkTo" :alt="altLink">{{ linkText | translate | capitalize  }}</router-link></span>
		</div>
		<div class="alert__exit">
			<button class="alert__close" data-dismiss="alert" aria-hidden="true" v-show="closeButton">×</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'alert',
		props: {
			conditional: {
				type: Boolean,
				required: true,
			},
			classFather: {
				type: String,
				required: false,
				default: '',
			},
			message: {
				type: String,
				required: true,
			},
			title: {
				type: String,
				required: false,
				default: '',
			},
			iconClass: {
				type: String,
				required: false,
				default: '',
			},
			linkShow: {
				type: Boolean,
				required: false,
				default: false,
			},
			linkText: {
				type: String,
				required: false,
				default: '',
			},
			linkTo: {
				type: String,
				required: false,
				default: '',
			},
			altLink: {
				type: String,
				required: false,
				default: '',
			},
			closeButton: {
				type: Boolean,
				required: false,
				default: false,
			},
		},
		methods: {
			successFalse() {
				this.$emit('close');
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/alert/alert.vue